module.exports = __webpack_public_path__ + "static/img/card-contact-h5.9bd8fb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-contact-h5.png
// module id = SQML
// module chunks = 34